import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Footer } from "../../components/Landing/Footer";
import { LandingPageLayout } from "../../Layout";
import { Partners } from "../../components/Landing/Partners";
import { ContactUs } from "../../components/Landing/ContactUs";
import { Centers } from "../../components/Landing/CentersAndSites";
import { withRouter } from "../../utils/withRouter";

class CentersLandingScreen extends React.Component {
  render() {
    return (
      <>
        <Navbar {...this.props} isFixed isShadowActive />
        <div className="main-landing-container" id="landingContainer">
          <LandingPageLayout id="sites">
            <div>
              <Centers searchText={this.props?.searchParams?.get("q")} />
            </div>
          </LandingPageLayout>
          <LandingPageLayout className="half-height light" id="partners">
            <Partners />
          </LandingPageLayout>
          <LandingPageLayout id="contactUs">
            <ContactUs />
          </LandingPageLayout>
          <Footer />
        </div>
      </>
    );
  }
}

export default withRouter(CentersLandingScreen);
